import { MapPin, Phone, Clock, ExternalLink, Mail } from "lucide-react";
import { BRANCHES } from "@/data/cybernet";

export const Branches = () => {
  return (
    <section
      id="sucursales"
      data-testid="branches-section"
      className="bg-white py-20 md:py-32"
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="mb-16 max-w-2xl">
          <div className="uppercase text-xs font-bold tracking-[0.25em] text-[#E10600] mb-4">
            — Sucursales
          </div>
          <h2 className="font-display font-black text-4xl sm:text-5xl tracking-tighter text-[#0A0A0A]">
            Visítanos en cualquiera de nuestras
            <br />
            <span className="text-[#E10600]">4 sucursales</span> en Cortazar.
          </h2>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-6">
          {BRANCHES.map((b) => (
            <article
              key={b.id}
              data-testid={`branch-card-${b.id}`}
              className="group flex flex-col border border-[#E4E4E7] p-6 hover:border-[#E10600] hover:-translate-y-1 transition-all duration-300 rounded-sm bg-white"
            >
              <div className="flex items-center justify-between mb-4">
                <span className="text-xs uppercase tracking-widest font-bold text-[#E10600]">
                  Desde {b.year}
                </span>
                <span className="h-2 w-2 rounded-full bg-[#E10600] animate-pulse" />
              </div>

              <h3 className="font-display font-black text-xl text-[#0A0A0A] leading-tight mb-2">
                {b.name}
              </h3>
              <p className="text-xs text-[#52525B] italic mb-6">
                {b.highlight}
              </p>

              <div className="space-y-4 flex-1">
                <div className="flex gap-3">
                  <MapPin className="h-4 w-4 text-[#E10600] shrink-0 mt-0.5" />
                  <p className="text-sm text-[#0A0A0A] leading-relaxed">
                    {b.address}
                  </p>
                </div>
                <div className="flex gap-3">
                  <Phone className="h-4 w-4 text-[#E10600] shrink-0 mt-0.5" />
                  <a
                    href={`tel:+52${b.phone.replace(/-/g, "")}`}
                    data-testid={`branch-phone-${b.id}`}
                    className="text-sm text-[#0A0A0A] font-medium hover:text-[#E10600]"
                  >
                    {b.phone}
                  </a>
                </div>
                <div className="flex gap-3">
                  <Mail className="h-4 w-4 text-[#E10600] shrink-0 mt-0.5" />
                  <a
                    href={`mailto:${b.email}`}
                    data-testid={`branch-email-${b.id}`}
                    className="text-xs text-[#0A0A0A] font-medium hover:text-[#E10600] break-all"
                  >
                    {b.email}
                  </a>
                </div>
                <div className="flex gap-3">
                  <Clock className="h-4 w-4 text-[#E10600] shrink-0 mt-0.5" />
                  <div className="text-xs text-[#52525B] space-y-1">
                    {b.hours.map((h, i) => (
                      <p key={i}>{h}</p>
                    ))}
                  </div>
                </div>
              </div>

              <a
                href={b.mapsUrl}
                target="_blank"
                rel="noopener noreferrer"
                data-testid={`branch-maps-${b.id}`}
                className="mt-6 inline-flex items-center justify-center gap-2 border-2 border-[#0A0A0A] text-[#0A0A0A] text-xs font-semibold px-4 py-3 rounded-sm hover:bg-[#0A0A0A] hover:text-white transition-colors"
              >
                <ExternalLink className="h-3.5 w-3.5" />
                Ver en Google Maps
              </a>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
};
